export default {
  default: () => import("/opt/buildhome/repo/layouts/default.vue").then(m => m.default || m),
  "non-grid": () => import("/opt/buildhome/repo/layouts/non-grid.vue").then(m => m.default || m)
}